/* eslint-disable import/prefer-default-export */
import apiInstance from 'services/api/apiInstance';

export { apiInstance };
